import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { takeUntil, switchMap, combineLatest, filter } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { AppState } from '../../../app.state';

import { Patient } from '../../../shared/models/patient.model';
import { Group } from '../../../shared/models/group.model';
import { Reason } from '../../../shared/models/reason.model';
import { DisplayNamePipe } from '../../../shared/pipes/display-name.pipe';

import { AppointmentsService } from '../../../shared/services/appointments.service';

import { getSelectedPatients } from '../reasons.reducer';
import { SetSelectedPatients, ResetSelectedPatients, UpdateConsecutiveDelay } from '../reasons.actions';
import { ReasonsService } from '../../../shared/services/reasons.service';

@Component({
  selector: 'linked-patients',
  template: require('./linked-patients.component.html'),
  styles: [require('./linked-patients.component.scss')]
})
export class LinkedPatientsComponent implements OnInit, OnDestroy {
  private patients: any[] = [];
  private group: Group;
  private reasonId: number;
  private currentReason: any;
  private destroy$: Subject<boolean> = new Subject();

  selectePatients$: Observable<any>;
  consecutiveDelay: number = 0;

  constructor(
    private store: Store<AppState>,
    private displayNamePipe: DisplayNamePipe,
    private appointmentsService: AppointmentsService,
    public reasonsService: ReasonsService,
    @Inject('$state') private $state,
    @Inject('ProductService') private productService,
    @Inject('LoadingService') private loadingService,
  ) {}

  ngOnInit(): void {
    this.loadingService.hide();

    this.selectePatients$ = this.store.select(getSelectedPatients);

    this.store.select((state: AppState): Reason => state.reasons.current)
      .pipe(
        filter((currentReason) => !!currentReason),
        switchMap((currentReason): Observable<any> => {
          this.currentReason = currentReason;
          return this.appointmentsService.getOfferingPatients(this.currentReason.offering.id);
        }),
        combineLatest(
          this.store.select((state: AppState): Group => state.group),
          this.store.select((state: AppState) => state.patients),
          (eligibleSubscriptions, group: Group, patients: any) => ({
            eligibleSubscriptions,
            group,
            patients,
          }),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe(({ eligibleSubscriptions, group, patients }): void => {
        if (!eligibleSubscriptions.length) {
          this.$state.go('patients.id.reasons.id.preferences', { reasonId: this.currentReason.id });
        }

        this.patients = Object.values(patients).filter((patient: Patient): Patient => eligibleSubscriptions[0].subscriptions.filter((subscription: any) => subscription.allowed).find((eligibleSubscription: any): boolean => eligibleSubscription.subscriptionId === patient.subscription.id));
        this.reasonId = eligibleSubscriptions[0].reasonId;
        this.group = group;
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  updatePatients(selectedPatients: string[]): void {
    this.store.dispatch(new SetSelectedPatients(this.patients.filter((patient) => selectedPatients.find((selectedPatient: string) => this.displayNamePipe.transform(patient) === selectedPatient))));
  }

  cancel() {
    this.store.dispatch(new ResetSelectedPatients());
    this.$state.go('patients.id.home');
  }

  next(): void {
    if (this.productService.isAvailable('PATIENT_FORMS') && this.currentReason.form && this.currentReason.form.questionsCount) {
      this.loadingService.show();

      this.$state.go('patients.id.reasons.id.form', {
        groupId: this.group.id,
        reasonId: this.currentReason.id,
      });
    } else if (this.reasonsService.hasPreferences(this.currentReason)) {
      this.$state.go('patients.id.reasons.id.preferences');
    } else {
      this.$state.go('patients.id.reasons.id.availabilities');
    }
  }

  updateConsecutiveDelay(): void {
    this.store.dispatch(new UpdateConsecutiveDelay(this.consecutiveDelay));
  }

  get patientsNames(): string[] {
    return Object.values(this.patients).map((patient) => this.displayNamePipe.transform(patient));
  }
}


// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/reasons/linked-patients/linked-patients.component.ts